import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { addModifier } from '../../player.type';
import { StatusEffect } from '../../status-effects.type';
import { NonMusicalTrait } from '../general/nonmusical';

export class PhoenixTrait extends Trait {
  static baseType = TraitType.Phoenix;
  static baseTitle = 'Phoenix Ashes';
  static baseText = 'At the start of your turn, gain rebirth up to half your current health.';
  static baseIcon = 'trait';

  type = PhoenixTrait.baseType;
  title = PhoenixTrait.baseTitle;
  text = PhoenixTrait.baseText;
  icon = PhoenixTrait.baseIcon;

  startTurn(): void {
    const health = this.owner.healthCurrent;
    const rebirth = this.owner.statusEffects.find((modifier) => {
      return modifier.type == StatusEffect.Rebirth;
    });

    if (rebirth) {
      return;
    }
    const amount = Math.floor(health / 2);
    addModifier(this.owner, StatusEffect.Rebirth, amount);
  }
}

TraitRegistry.register(PhoenixTrait.baseType, PhoenixTrait);
